if (! customElements.get('appstle-price-updater')) {
  console.info("AppstlePriceUpdater: Registering custom element.");

  /**
   * @classdesc Custom Element responsible for updating Appstle subscription widget 
   * price elements.
   * 
   */
  class AppstlePriceUpdater extends HTMLElement {
    constructor() {
      super();

      // Selectors mapped to internal logic
      this.selectors = {
        rootSelector: '.appstle_subscription_wrapper',
        priceWrapper: '.appstle_one_time_price_wrapper',
        // Visible elements
        currentAmount: '.appstle_subscription_amount',
        compareAt: '.appstle_subscription_amount_compare_at_price',
        // Screen Reader elements
        currentAmountSR: '.appstle_subscription_amount-appstle-sr-only',
        compareAtSR: '.appstle_subscription_amount_compare_at_price-appstle-sr-only'
      };

      // Prefixes for accessibility text
      this.srPrefixes = {
        sale: 'Sale price ',
        original: 'Original price '
      };
    }

    /**
     * Lifecycle callback: Called when the element is added to the DOM.
     */
    connectedCallback() {
      // Attempt an initial update if the attribute exists
      const price = this.getAttribute('discount_price');
      if (price) {
        document.addEventListener(
          'AppstleSubscription:SubscriptionWidget:SubscriptionWidgetUpdated',
          debounce((event) => {
            console.info("AppstlePriceUpdater: Initial update triggered.");
            this.updateAppstleWrapper(price)
          }, 200)

        );
      }
    }

    /**
     * Executes the logic to update prices.
     * @param {string} discountPrice - The new price string (e.g., "$35.00")
     */
    updateAppstleWrapper(discountPrice) {
      if (!discountPrice) return;

      // 1. Get appstle_subscription_wrapper
      const wrapper = document.querySelector(this.selectors.rootSelector);

      if (!wrapper) {
        console.warn("AppstlePriceUpdater: Wrapper %s not found.", this.selectors.rootSelector);
        return;
      }

      // 2. Find appstle_one_time_price_wrapper
      // Scoped search within the found wrapper
      const priceWrapper = wrapper.querySelector(this.selectors.priceWrapper);

      if (!priceWrapper) {
        console.warn("AppstlePriceUpdater: Price wrapper %s not found.", this.selectors.priceWrapper);
        return;
      }

      // Select the specific price span elements
      const currentPriceEl = priceWrapper.querySelector(this.selectors.currentAmount);
      const compareAtEl = priceWrapper.querySelector(this.selectors.compareAt);

      // Accessibility Best Practice: Also target screen reader (sr-only) spans if they exist
      const currentPriceSrEl = priceWrapper.querySelector(this.selectors.currentAmountSR);
      const compareAtSrEl = priceWrapper.querySelector(this.selectors.compareAtSR);

      if (currentPriceEl && compareAtEl) {
        // 3. Set text of appstle_subscription_amount_compare_at_price element to text in appstle_subscription_amount
        if (!compareAtEl.textContent.trim()) {
          const originalPrice = currentPriceEl.textContent;
          
          compareAtEl.textContent = originalPrice;
          
          // Handle SR-only element
          if (compareAtSrEl) {
              compareAtSrEl.textContent = `Original price ${originalPrice}`;
          }
        }

        // 4. Set text in appstle_subscription_amount to discount_price
        currentPriceEl.textContent = discountPrice;
        
        // Handle SR-only element
        if (currentPriceSrEl) {
          currentPriceSrEl.textContent = `Sale price ${discountPrice}`;
        }
      }
    }
  }
  /**
   * Register the custom element
   * 
   * @param {string} discount_price - The new price string (e.g., "$35.00")
   * 
   * @usage
   * <appstle-price-updater discount_price="$19.99"></appstle-price-updater>
   */
  document.addEventListener('DOMContentLoaded', () => customElements.define('appstle-price-updater', AppstlePriceUpdater));
}
